import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import MDTypography from "components/MDTypography";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <MDTypography component={"span"}>{children}</MDTypography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function TabPanel({ items, value, onChange }) {
  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderColor: "divider" }}>
        <Tabs value={value} onChange={onChange} aria-label="basic tabs example">
          {items.map((item, index) => {
            return (
              <Tab
                label={item.label}
                key={item.label + " - label"}
                {...a11yProps(index)}
              />
            );
          })}
        </Tabs>
      </Box>

      {items.map((item, index) => {
        return (
          <CustomTabPanel
            key={item.label + " - panel"}
            value={value}
            index={index}
          >
            {item.panel}
          </CustomTabPanel>
        );
      })}
    </Box>
  );
}
